import React from 'react';
import { Result } from 'antd';

interface NoAccessProps {
    email?: string;
}

export default function NoAccess({ email = 'edi@redwoodlogistics.com' }: NoAccessProps) {
    return (
        <Result
            status="403"
            title="You don't have access"
            subTitle={
                <span>
                    You do not have permission to access this application. Please send an email to{' '}
                    <a href={`mailto:${email}`}>{email}</a> for requesting access.
                </span>
            }
        />
    );
}
